import { dateShortOut } from 'Data/format.js'
import { date } from 'Data/validate.js'

export function formatOutDate(value) {
  let length = value.split('/')?.[2]?.length
  if (!length) return value

  let formatted = dateShortOut(value)
  let isValid = date(formatted)
  return length !== 4 || !isValid ? value : formatted
}
